<template>
	<div class="page">
		<ul uk-tab>
			<li class="uk-active" @click="resetPreview"><a href="#template-settings">{{ $t('html') }}</a></li>
			<li><a href="#additional-settings" @click="resetPreview">{{ $t('text') }}</a></li>
			<li>
				<a href="#preview" @click="getPreview">
					{{ $t('preview') }}
					<div v-if="preloader" class="spinner-border" role="loading"></div>
				</a>
			</li>
		</ul>
		<ul class="uk-switcher uk-margin">
			<li id="template-settings">
				<div class="row">
					<div class="col-sm-6">
						<div class="modal_item">
							<label>{{ $t('name') }}</label>
							<br>
							<input class="textInput attribute-editor" type="text" v-model="name">
							<button class="button_reset fa fa-times"></button>
						</div>
					</div>
				</div>
				<div class="modal_item">
					<label>{{ $t('html.message.template') }}</label>
					<br>
					<div class="row">
						<div class="col-sm-9">
							<editor v-model="htmlMessageTemplate" @init="editorInit" class="editor" lang="html" theme="chrome"
									width="100%" height="555"></editor>
						</div>
						<div class="col-sm-3 attr-wrapper">
							<div class="attr-title">
								{{ $t('attributes') }}
							</div>
							<div class="attr-search">
								<input type="text" :placeholder="$t('filter')" v-model="attrSearchInput">
								<span class="clear"
									  @click="attrSearchInput = ''">&times;</span>
							</div>
							<div class="attr">

								<div class="attribute" @click="addCycle">{cycle:items}</div>
								<div class="attribute" v-for="(attr, key) in filteredTableColumns" :key="key"
									 @click="addMnemonics(attr.columnName)">{{ '{' + attr.columnName + '}' }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</li>
			<li id="additional-settings">
				<div class="modal_item">
					<label>{{ $t('text.message.template') }}</label>
					<br>
					<textarea class="textInput attribute-editor" type="text" v-model="textMessageTemplate"></textarea>
					<button class="button_reset fa fa-times"></button>
				</div>
			</li>
			<li id="preview">
				<div class="preview_frame">
					<iframe style="pointer-events:none;" :src="'data:text/html,' + htmlPreview" :srcdoc="htmlPreview" width="100%" height="500px" sandbox></iframe>
				</div>
				<p class="preview_info">{{ $t('preview.info') }}</p>
			</li>
		</ul>
	</div>
</template>

<script>

import http from 'utils/http'

export default {
	name: 'NotificationTemplatesModal',
	props: [
		'companyId'
	],
	components: {
		editor: require('vue2-ace-editor')
	},
	data () {
		return {
			name: '',
			htmlMessageTemplate: null,
			textMessageTemplate: '',

			editor: {},
			htmlPreview: '',
			preloader: false,

			attrSearchInput: '',
			manager: {}
		}
	},
	computed: {
		tableColumns: function () {
			return this.$store.getters.getTableColumn.filter(attr => attr.hasOwnProperty('columnName')).sort((a, b) => {
				let fa = a.columnName.toLowerCase(),
					fb = b.columnName.toLowerCase();

				if (fa < fb) {
					return -1;
				}
				if (fa > fb) {
					return 1;
				}
				return 0;
			})
		},
		filteredTableColumns: function () {
			let vm = this
			if (!this.attrSearchInput) {
				return this.tableColumns
			} else {
				return this.tableColumns.filter(function (attr) {
					return attr.columnName.toLowerCase().indexOf(vm.attrSearchInput) !== -1
				})
			}
		},
		action: function () {
			return window.manager.action
		}
	},
	async mounted () {
		let vm = this

		vm.manager = window.manager

		await Swal.fire({
			title: vm.$t('notification.templates'),
			html: vm.$el,
			width: '70rem',
			confirmButtonText: vm.$t('save'),
			showCancelButton: true,
			cancelButtonText: vm.$t('cancel'),
			buttonsStyling: false,
			allowOutsideClick: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				popup: 'button-actions',
				content: 'form ',
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small'
			},
			onBeforeOpen: function () {
				if (vm.action === 'edit') {
					vm.setDataTemplate()
				}
			},
			onRender: function () {

			},
			onClose: function () {
				vm.$emit('close-modal')
			},
			preConfirm: async function () {
				let htmlTemplate = vm.editor.getValue()

				let validation = await vm.validationTemplate(htmlTemplate)

				if (!validation) return false

				return {
					companyId: vm.companyId,
					name: vm.name,
					textMessageTemplate: vm.textMessageTemplate || null,
					htmlMessageTemplate: htmlTemplate
				}
			}
		}).then(function (result) {
			if (result.value) {
				if (vm.action === 'edit') {
					result.value.id = vm.manager.template.id
				}
				manager.saveTemplate(vm.action, result.value)
			}
		})
	},
	methods: {
		addCycle: function () {
			this.editor.insert('{cycle:items}{cycle:items}')
		},
		addMnemonics: function (attr) {
			this.editor.insert('{' + attr + '}')
		},
		editorInit: function (editor) {
			require('brace/mode/html')
			require('brace/theme/chrome')
			require('brace/snippets/html')

			require(['emmet/emmet'], function (data) {
				window.emmet = data.emmet
			})

			window.editor = editor

			this.editor = editor
		},
		setDataTemplate: function () {
			let vm = this
			http.post('template/get', {}, {
				params: {
					id: this.manager.template.id
				}
			}).then(response => {
				vm.name = response.data.name
				vm.subject = response.data.subject
				vm.textMessageTemplate = response.data.textMessageTemplate
				vm.htmlMessageTemplate = vm.editor.setValue(response.data.htmlMessageTemplate)
			})
		},
		validationTemplate: function (template) {
			return http.post('/template/validate', {template: template}, {})
				.then(() => true)
				.catch(error => {
				Swal.showValidationMessage(error.data)
				return false
			})
		},
		getPreview: async function () {
			let vm = this

			if (vm.htmlMessageTemplate) {
				vm.preloader = true
				let validation = await vm.validationTemplate(vm.htmlMessageTemplate)

				if (validation) {
					http.post('/items/ids', {}, {}).then(response => {
						let ids = response.data.slice(0, 10)
						http.post('/template/preview', {
							"itemIds": ids,
							"template": vm.htmlMessageTemplate
						}, {})
							.then(response => {
								vm.htmlPreview = response.data
								vm.preloader = false
							})
					})
				} else {
					vm.preloader = false
					vm.htmlPreview = ''
				}
			}
		},
		resetPreview: function () {
			this.htmlPreview = ''
		}
	},
	beforeDestroy () {
		this.editor = {}
	}
}
</script>

<style scoped lang="scss">

textarea {
	max-width: 100%;
	min-width: 100%;
	min-height: 200px;
}

.attr {
	height: 29.2rem;
	overflow-y: scroll;
	border: 1px solid #ebeef5;
	border-top: none;
	padding: 0 15px 15px;
	border-radius: 0 0 8px 8px;
}

.attr button {
	margin-bottom: 5px;
	display: block;
}

.attr .attribute {
	text-align: left;
	font-size: 14px;
	word-break: break-word;
	background-color: #fff;
	color: #333;
	padding: 6px;
	border-bottom: 1px solid #ebeef5;
	cursor: pointer;
}

.attr-wrapper {
	height: 35rem;
}

.attr-search {
	padding: 5px 15px 0 15px;
	height: 40px;
	border: 1px solid #ebeef5;
	border-top: none;
	border-bottom: none;
}

.attr-search input[type="text"] {
	border: 1px solid #ebeef5;
	padding: 5px;
	margin-bottom: 5px;
	width: 100%;
}

.attr-search input[type="text"]:focus {
	outline: none;
}

.attr-title {
	padding: 18px;
	border: 1px solid #ebeef5;
	border-radius: 8px 8px 0 0;
	color: #303133;
}

.attr-search .clear {
	cursor: pointer;
	margin-left: 3px;
	border: 1px solid #ebeef5;
	padding: 5px;
	position: absolute;
	right: 30px;
	background-color: #fff;
}

.el-tiptap-editor__content td {
	width: 100px;
}
.preview_frame {
	background: transparent;
}
.preview_info {
	margin: 5px 0;
	text-align: left;
	font-size: 14px;
}
.iframe {
	z-index: -2;
}

.spinner-border {
	display: inline-block;
	position: absolute;
	top: 5px;
	right: -22px;
	width: 15px;
	height: 15px;
	vertical-align: text-bottom;
	border: .25em solid #ececec;
	border-right-color: transparent;
	border-radius: 50%;
	-webkit-animation: spin .75s linear infinite;
	animation: spin .75s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
